export default "__VITE_ASSET__2cdf44f7__"